import { Type } from 'class-transformer';
import {
  IsArray,
  IsBoolean,
  IsDateString,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  MaxLength,
  ValidateIf,
  ValidateNested,
} from 'class-validator';
import { CaseLineModel } from './case-line.model';
import { CasePickupValidateDto } from './case-pickup-validate.dto';
import { CaseStatus } from './case-status.enum';
import { CaseType } from './case-type.enum';

export class UpsertCaseServiceBusDto {
  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  public id: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  public accountId: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  public caseNumber: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  public userId: string;

  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  public type: CaseType;

  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  public status: CaseStatus;

  @IsString()
  @IsNotEmpty()
  @MaxLength(255)
  public subject: string;

  @IsDateString()
  @IsNotEmpty()
  public createdAt: Date;

  @IsString()
  public returnOrderNumber: string;

  @IsArray()
  public lines: CaseLineModel[];

  // for warranty type
  @IsBoolean()
  @IsOptional()
  public isRefund?: boolean;

  @IsString()
  @MaxLength(255)
  @IsOptional()
  public refundStatus?: string;

  @IsString()
  @MaxLength(255)
  @IsOptional()
  public reason?: string;

  // for return type
  @IsNumber()
  @IsOptional()
  public itemsTotalQuantity?: number;

  @IsNumber()
  @IsOptional()
  public itemsOpen?: number;

  @IsNumber()
  @IsOptional()
  public itemsApproved?: number;

  @IsNumber()
  @IsOptional()
  public itemsDeclined?: number;

  @IsString()
  @MaxLength(255)
  @IsOptional()
  public description?: string;

  /**
   * Object that contains the details of pickup for return case
   */
  @ValidateIf((body) => !!body.pickup)
  @ValidateNested()
  @Type(() => CasePickupValidateDto)
  public pickup?: CasePickupValidateDto;

  // @deprecated
  @IsString()
  @MaxLength(255)
  @IsOptional()
  public contactId?: string;

  // @deprecated
  @IsString()
  @MaxLength(255)
  @IsOptional()
  public erpId?: string;

  // TODO: Remove _id once all the failed messages are processed from the service bus
  @IsString()
  @MaxLength(255)
  @IsOptional()
  public _id?: string;
}
